var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advantages-wrap moveRight",style:({backgroundColor: _vm.bgcolor})},[_c('div',{staticClass:"advantages-inner"},[_c('h2',[_vm._v("PBSD 产品优势")]),_c('h3',[_vm._v("Advantage of PBSD")]),_c('AdvantageItems')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }